import React, { createContext, useState } from 'react';

const initialState = {
  payrollProcess: {},
  reliquidationProcess: {}
};

export const PayrollProcessContext = createContext({});

export const PayrollProcessProvider = ({ children }) => {
  const [payrollProcess, setPayrollProcess] = useState(initialState);
  const [reliquidationProcess, setReliquidationProcess] = useState(initialState);
  return (
    <PayrollProcessContext.Provider
      value={{ payrollProcess, setPayrollProcess, reliquidationProcess, setReliquidationProcess }}
    >
      {children}
    </PayrollProcessContext.Provider>
  );
};
